(function ($) {$(function(){
    const postsContainer = $('.posts-container');
    const bgLoop = $('#posts-bg-loop');
    const loopPlayer1 = $('#post-loop-video1');
    const loopPlayer2 = $('#post-loop-video2');
    const postsLinks = $('a.post-link');
    const categories = $('.categories-container .cat-name');
    const videoTitle = $('.video-info .video-title');
    const videoSubtitle = $('.video-info .video-subtitle');
    if (postsLinks.length) {
        postsLinks.parent().hover(onEnter, onLeave);
    }
    if (categories.length) {
        categories.hover(onEnterCategories, onLeaveCategories);
        categories.each(function () {
            const $this = $(this);
            $this.css('--mw', Math.ceil($this.outerWidth())  + 10);
        })
    }
    // if (postsContainer.length) {
    //     postsContainer.hover(null, disableVideos);
    // }

    // loopPlayer1.on('canplay', function() {
    //     bgLoop.get(0).pause();
    //     loopPlayer1.addClass('active')
    //     loopPlayer2.removeClass('active')
    //     loopPlayer2.get(0).pause()
    //     // setTimeout(() => { loopPlayer2.get(0).pause()}, 300);

    //     // window.absoluteCenterVideo()
    // });
    // loopPlayer2.on('canplay', function() {
    //     bgLoop.get(0).pause();
    //     loopPlayer2.addClass('active')
    //     loopPlayer1.removeClass('active')
    //     loopPlayer1.get(0).pause();
    //     // setTimeout(() => { loopPlayer1.get(0).pause(); }, 300);

    //     // window.absoluteCenterVideo()
    // });
    function onEnter(){
        
        const $this = $(this).find('a');
        const $videosContainer = $('.page-template-PostLanding #preview-player');
        const $bgLoop = $('#posts-bg-loop');
        const $activeVideo = $videosContainer.find('video.active').not($bgLoop);

        if ($this.data('video-loop') != $activeVideo.attr('src')) {
            const $matchingVideo = $videosContainer.find('video[src="'+ $this.data('video-loop') +'"]');
            if ($matchingVideo.attr('src')) {
                $matchingVideo.addClass('active');
                $matchingVideo.get(0).play();
                $videosContainer.find('video').not($matchingVideo).each(function(){
                    const $this = $(this);
                    // if ($this.attr('id') != 'posts-bg-loop') {
                    // }
                    $this.removeClass('active');
                    $this.get(0).pause();
                });
            }
        }


        videoTitle.html($this.data('video-title'));
        videoSubtitle.html($this.data('video-subtitle'));
        categories.removeClass('focus');
        const activeCat = categories.parent().find('[data-cat="' + $this.data('post-cat') + '"]')
        if (activeCat.length) { 
            categories.addClass('no-focus');
            activeCat.addClass('focus'); 
        }
        postsLinks.removeClass('active');
        postsLinks.addClass('no-focus');
        // if (loopPlayer1.get(0).paused) {
        //     if (loopPlayer2.attr('src') != $this.data('video-loop')) {
        //         loopPlayer1.attr('src', $this.data('video-loop'));
        //     }
        // } else {
        //     if (loopPlayer1.attr('src') != $this.data('video-loop')) {
        //         loopPlayer2.attr('src', $this.data('video-loop'));
        //     }
        // }
    }
    function onLeave(){
        categories.removeClass('focus');
        categories.removeClass('no-focus');
        postsLinks.removeClass('no-focus');

        const $this = $(this).find('a');
        const $videosContainer = $('.page-template-PostLanding #preview-player');
        const $bgLoop = $('#posts-bg-loop');
        const $activeVideo = $videosContainer.find('video.active').not($bgLoop);
        $activeVideo.removeClass('active');
        $activeVideo.get(0).pause();
        $bgLoop.get(0).play();
        $bgLoop.addClass('active');
        $videosContainer.addClass('landscape');
        videoTitle.html('');
        videoSubtitle.html('');
    }

    function disableVideos(){
        bgLoop.get(0).play();
        loopPlayer1.removeClass('active')
        loopPlayer2.removeClass('active')
        videoTitle.html('');
        videoSubtitle.html('');
        loopPlayer1.get(0).pause()
        loopPlayer2.get(0).pause()
        loopPlayer1.attr('src', '');
        loopPlayer2.attr('src', '');
    }

    function onEnterCategories() {
        const $this = $(this);
        $this.addClass('focus');
        categories.addClass('no-focus');
        const catName = $this.data('cat');
        const posts = postsLinks.parent().find('[data-post-cat="' + catName + '"]')
        if (posts.length > 0) {
            postsLinks.addClass('no-focus')
            posts.addClass('focus');
        }
    }
    function onLeaveCategories() {
        const $this = $(this);
        $this.removeClass('focus');
        categories.removeClass('no-focus');
        postsLinks.removeClass('focus')
        postsLinks.removeClass('no-focus')
    }
});}(_jQ3));

